import * as types from "./actionTypes";
import * as apiUrls from "./apiUrls";
import axios from 'axios';
import { closeModal } from "../shared/actions";
import { toast } from "react-toastify";
import {
  startLoading,
  stopLoading,
} from '../shared/actions';

export function fetchAlerts(email, page=1) {
  return (dispatch) => {
    dispatch(startLoading());

    const apiUrl = apiUrls.alerts();

    return axios(
      apiUrl,
      {
        params: {
          email: email,
          page: page
        },
        method: "GET",
      }
    )
    .then(response => {
      if (response.status === 200) {
        const totalPages = response.data.pagy.pages;
        const totalCount = response.data.pagy.count;
        const currentPage = response.data.pagy.page;

        dispatch({
          type: types.ALERTS_FETCH_SUCCESS,
          payload: response.data.data,
        })

        dispatch({
          type: types.UPDATE_ALERTS_TOTAL_PAGES,
          payload: totalPages,
        });
        dispatch({
          type: types.UPDATE_ALERTS_CURRENT_PAGE,
          payload: currentPage,
        });
        dispatch({
          type: types.UPDATE_ALERTS_TOTAL_COUNT,
          payload: totalCount,
        });

        dispatch(stopLoading());
      }
    })
    .catch(errors => {
      const errorMessage = errors.message;
      toast.error(errorMessage);
    })
  };
}

export function updateAlert(id, payload) {
  return (dispatch) => {
    const apiUrl = apiUrls.updateAlert(id);

    return axios.put(
      apiUrl,
      {
        project_alert: payload
      }
    )
    .then(response => {
      if (response.status === 200) {
        dispatch({
          type: types.UPDATE_ALERT_SUCCESS,
          payload: response.data.data,
        })
        toast.success("Changes Saved!");
        dispatch(closeModal('editAlertModal'))
      }
    })
    .catch(errors => {
      if (errors.request.status === 422) {
        toast.warning("Alert already exists");
        return;
      }

      const errorMessage = errors.message;
      toast.error(errorMessage);
    })
  };
}

export function deleteAlert(id, email) {
  return (dispatch) => {
    const apiUrl = apiUrls.updateAlert(id);

    return axios.delete(apiUrl, {
      data: {
        email: email
      }
    })
    .then(response => {
      if (response.status === 200) {
        const totalPages = response.data.pagy.pages;
        const totalCount = response.data.pagy.count;
        const currentPage = response.data.pagy.page;

        setTimeout(() => {
          toast.success("The project alert was deleted!");
        }, deleteAlertSuccess(dispatch, response.data.data, totalPages, currentPage, totalCount));
      }
    })
    .catch(errors => {
      const errorMessage = errors.message;
      toast.error(errorMessage);
    })
  };
}


function deleteAlertSuccess(dispatch, alert, totalPages, currentPage, totalCount) {
  dispatch({
    type: types.DELETE_ALERT_SUCCESS,
    payload: alert,
  });
  dispatch({
    type: types.UPDATE_ALERTS_TOTAL_PAGES,
    payload: totalPages,
  });
  dispatch({
    type: types.UPDATE_ALERTS_CURRENT_PAGE,
    payload: currentPage,
  });
  dispatch({
    type: types.UPDATE_ALERTS_TOTAL_COUNT,
    payload: totalCount,
  });
}


// WEBPACK FOOTER //
// ./src/features/alertsManager/actions.js